import { mapRange } from '@wix/wow-utils';
import { getEasing } from '../../utils';
const POWER_TO_BOUNCE_FACTOR_MAP = {
  soft: 1,
  medium: 2,
  hard: 3
};
const TRANSLATE_Y_KEYFRAMES = [{
  keyframe: 0,
  translateY: 0
}, {
  keyframe: 8.8,
  translateY: -55
}, {
  keyframe: 17.6,
  translateY: -87
}, {
  keyframe: 26.5,
  translateY: -98
}, {
  keyframe: 35.3,
  translateY: -87
}, {
  keyframe: 44.1,
  translateY: -55
}, {
  keyframe: 53.1,
  translateY: 0
}, {
  keyframe: 66.2,
  translateY: -23
}, {
  keyframe: 81,
  translateY: 0
}, {
  keyframe: 86.8,
  translateY: -5
}, {
  keyframe: 94.1,
  translateY: 0
}, {
  keyframe: 97.1,
  translateY: -2
}, {
  keyframe: 100,
  translateY: 0
}];
export default function create(options) {
  const {
    power = 'soft',
    intensity = 0.3
  } = options.namedEffect;
  const duration = options.duration || 0;
  const delay = options.delay || 0;
  const responsiveBounceFactor = mapRange(0, 1, POWER_TO_BOUNCE_FACTOR_MAP.soft, POWER_TO_BOUNCE_FACTOR_MAP.hard, intensity);
  const bounceFactor = POWER_TO_BOUNCE_FACTOR_MAP[power] || responsiveBounceFactor;
  const easing = getEasing('sineOut');
  const keyframes = TRANSLATE_Y_KEYFRAMES.map(_ref => {
    let {
      keyframe,
      translateY
    } = _ref;
    return {
      offset: keyframe / 100 * (duration / (duration + delay)),
      translate: `0px ${translateY * bounceFactor / 2}px`,
      easing
    };
  });
  return [{
    ...options,
    delay: 0,
    easing: 'linear',
    duration: duration + delay,
    keyframes
  }];
  /*
   *
   * @keyframes <name> {
   *   <duration / (duration + delay)> {
   *     translate: `0px <(translateY * bounceFactor) / 2>px`
   *   }
   *   100% {
   *     translate: `0px 0px`
   *   }
   * }
   *
   *
   * #target {
   *   animation: <name> <duration + delay> infinite;
   * }
   */
}
//# sourceMappingURL=Bounce.js.map